import React, { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { Box } from "@chakra-ui/react";
import { registerGsapPlugins } from "lib/gsap";
import { StepOneSvg } from "./step-1-svg";

registerGsapPlugins(ScrollTrigger);

export function StepOneAnimation() {
  const ref = useRef<HTMLDivElement>(null);
  const timeline = useRef<GSAPTimeline>();

  useGSAP(
    () => {
      timeline.current = gsap
        .timeline({
          delay: 0.75,
          repeat: -1,
          repeatDelay: 2,
          defaults: {
            duration: 0.75,
            ease: "power2.inOut",
          },
          scrollTrigger: {
            trigger: "#aid-step-1-svg",
            onEnter: () => timeline.current?.restart(true),
            onLeave: () => timeline.current?.pause(),
            onEnterBack: () => timeline.current?.restart(true),
            onLeaveBack: () => timeline.current?.pause(),
          },
        })
        .from("#repeat-purchase-outer-circle", {
          fill: "var(--chakra-colors-new-blue-900)",
          fillOpacity: 0.5,
        })
        .from(
          "#repeat-purchase-inner-top",
          {
            fill: "var(--chakra-colors-new-blue-500)",
            fillOpacity: 0.5,
          },
          "<",
        )
        .from(
          "#repeat-purchase-inner-bottom",
          {
            fill: "var(--chakra-colors-new-blue-700)",
            fillOpacity: 0.5,
          },
          "<",
        )
        .from(
          "#repeat-purchase-indicator",
          {
            fill: "var(--chakra-colors-new-gray-500)",
            duration: 0.4,
          },
          "<+0.15",
        )
        .to(
          "#repeat-purchase-inner-circle",
          {
            rotation: 360,
            transformOrigin: "50% 50%",
            duration: 3,
            ease: "power2.in",
          },
          "-=0.35",
        )
        .to("#repeat-purchase-inner-circle", {
          rotation: "+=360",
          transformOrigin: "50% 50%",
          duration: 1,
          ease: "linear",
        })
        .to("#repeat-purchase-inner-circle", {
          rotation: "+=360",
          transformOrigin: "50% 50%",
          duration: 3.5,
          ease: "power2.out",
        })
        .to(
          "#repeat-purchase-indicator",
          {
            fill: "var(--chakra-colors-new-gray-500)",
            duration: 0.6,
            ease: "power3.out",
          },
          "-=0.35",
        )
        .to(
          "#repeat-purchase-outer-circle",
          {
            fill: "var(--chakra-colors-new-blue-900)",
            fillOpacity: 0.5,
          },
          "<",
        )
        .to(
          "#repeat-purchase-inner-top",
          {
            fill: "var(--chakra-colors-new-blue-500)",
            fillOpacity: 0.5,
          },
          "<",
        )
        .to(
          "#repeat-purchase-inner-bottom",
          {
            fill: "var(--chakra-colors-new-blue-700)",
            fillOpacity: 0.5,
          },
          "<",
        );
    },
    { scope: ref },
  );

  return (
    <Box ref={ref} boxSize="100%">
      <StepOneSvg id="aid-step-1-svg" boxSize="100%" />
    </Box>
  );
}
